import { eventsConstants } from '_store/_constants/events.constants';

const initialState = {
  events: {
    data: [],
    page: 1,
    limit: 10,
    total: 0
  },
  event: null,
  registrations: {
    data: [],
    page: 1,
    limit: 10,
    total: 0
  },
  whatsAppConfigs: {
    data: [],
    page: 1,
    limit: 10,
    total: 0
  },
  isLoading: false,
  error: null
};

export function events(state = initialState, action) {
  switch (action.type) {
    // Events
    case eventsConstants.FETCH_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case eventsConstants.FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.events,
        isLoading: false
      };
    case eventsConstants.FETCH_EVENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case eventsConstants.FETCH_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case eventsConstants.FETCH_EVENT_SUCCESS:
      return {
        ...state,
        event: action.event,
        isLoading: false
      };
    case eventsConstants.FETCH_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case eventsConstants.CREATE_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case eventsConstants.CREATE_EVENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case eventsConstants.CREATE_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case eventsConstants.UPDATE_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case eventsConstants.UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        event: action.event,
        isLoading: false
      };
    case eventsConstants.UPDATE_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case eventsConstants.DELETE_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case eventsConstants.DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: {
          ...state.events,
          data: state.events.data.filter(event => event._id !== action.id),
          total: state.events.total - 1
        },
        isLoading: false
      };
    case eventsConstants.DELETE_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    // Registrations
    case eventsConstants.FETCH_EVENT_REGISTRATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case eventsConstants.FETCH_EVENT_REGISTRATIONS_SUCCESS:
      return {
        ...state,
        registrations: action.registrations,
        isLoading: false
      };
    case eventsConstants.FETCH_EVENT_REGISTRATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    // WhatsApp Configs
    case eventsConstants.FETCH_WHATSAPP_CONFIGS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case eventsConstants.FETCH_WHATSAPP_CONFIGS_SUCCESS:
      return {
        ...state,
        whatsAppConfigs: action.configs,
        isLoading: false
      };
    case eventsConstants.FETCH_WHATSAPP_CONFIGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    default:
      return state;
  }
}

export default events;
